import { Outlet, useNavigate, useLocation } from 'react-router-dom';

const S = {
  shell: { display: 'flex', minHeight: '100vh', background: 'var(--bone-soft)' },
  sidebar: {
    width: 220,
    background: 'var(--slate)',
    color: 'var(--bone)',
    padding: '32px 24px',
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
  },
  brand: {
    fontFamily: 'var(--wordmark)',
    fontSize: 16,
    letterSpacing: '.14em',
    fontWeight: 500,
    marginBottom: 32,
    lineHeight: 1.3,
  },
  link: (active) => ({
    fontFamily: 'var(--label)',
    fontSize: 11,
    letterSpacing: '.24em',
    textTransform: 'uppercase',
    padding: '12px 14px',
    cursor: 'pointer',
    background: active ? 'rgba(255,255,255,.07)' : 'none',
    border: 'none',
    color: active ? 'var(--bone)' : 'var(--bronze-60)',
    textAlign: 'left',
    transition: 'color .2s, background .2s',
  }),
  logout: {
    fontFamily: 'var(--label)',
    fontSize: 10,
    letterSpacing: '.24em',
    textTransform: 'uppercase',
    color: 'var(--bronze-30)',
    cursor: 'pointer',
    background: 'none',
    border: 'none',
    textAlign: 'left',
    marginTop: 'auto',
    padding: '12px 14px',
  },
  main: { flex: 1, padding: '40px clamp(24px, 4vw, 56px)' },
};

const NAV = [
  { path: '/admin', label: 'Articles' },
  { path: '/admin/media', label: 'Media' },
];

export default function AdminLayout() {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const handleLogout = () => {
    localStorage.removeItem('token');
    navigate('/admin/login');
  };

  return (
    <div style={S.shell}>
      <aside style={S.sidebar}>
        <div style={S.brand}>DEXON<br />LEGAL</div>
        {NAV.map(({ path, label }) => (
          <button key={path} style={S.link(pathname === path || (path !== '/admin' && pathname.startsWith(path)))} onClick={() => navigate(path)}>
            {label}
          </button>
        ))}
        <button style={S.logout} onClick={handleLogout}>Log out</button>
      </aside>
      <main style={S.main}>
        <Outlet />
      </main>
    </div>
  );
}
